
import { mapState } from "vuex";

import { campaignMixin } from "~/mixins";

export default {
  mixins: [campaignMixin],

  props: {
    tileLabel: { type: String, default: "" },
    isSelected: { type: Boolean, default: false },
    targetVariant: { type: Object, required: true },
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
    price() {
      return this.targetVariant.price;
    },
    compareAtPrice() {
      return this.targetVariant.compareAtPrice;
    },
  },
};
